<form #f="ngForm" [formGroup]="phoneForm">
  <ngx-intl-tel-input
    [cssClass]="'form-control'"
    [preferredCountries]="preferredCountries"
    [enableAutoCountrySelect]="true"
    [enablePlaceholder]="true"
    [searchCountryFlag]="false"
    [searchCountryField]="[
      SearchCountryField.Iso2,
      SearchCountryField.Name
    ]"
    [selectFirstCountry]="false"
    [selectedCountryISO]="CountryISO.Brazil"
    [maxLength]="15"
    [phoneValidation]="true"
    [separateDialCode]="separateDialCode"
    [numberFormat]="PhoneNumberFormat.International"
    name="phone"
    formControlName="phone"
    (ngModelChange)="checkNumber()"
    >
  </ngx-intl-tel-input>
</form>
